export default __webpack_public_path__ + "static/media/DSC08972.3492f91f.jpg";